import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from '../../utils/obj-utils';
import { isNullOrUndefined } from '../../../../../general/js/general-helpers';

function SSOFormFooter({
    onSubmit,
    isHidden,
    linkCallBackUrl,
    footerButtonText,
    footerLinkText,
    useYellowButton,
    isSubmit = true,
}) {
    function getFooterLink() {
        if (!linkCallBackUrl ||
            isEmpty(footerLinkText)) {
            return null;
        }
        return (<a id='forgottenPassword' className='link form__sign-in-link' onClick={linkCallBackUrl}
        >
            {footerLinkText}
        </a>);
    }

    const buttonClass = isNullOrUndefined(useYellowButton) || !useYellowButton 
                        ? 'button button--primary auto-mt-md'
                        : 'button button--primary button--primary--yellow auto-mt-md';

    return (
        <div className='form__sign-in'
            style={{ display: isHidden ? 'none' : 'flex' }}>
            <button
                className={buttonClass}
                type={isSubmit ? 'submit' : 'button'}
                id='signInFormModal'
                data-dc-form-sso-ref='submit-button'
                onClick={onSubmit}
            >
                <span className='button-content button-content--icon'>
                    <span>{footerButtonText}</span>
                    <svg
                        className='icon button__arrow-right'
                        width='14'
                        height='12'
                        focusable='false'
                    >
                        <use xlinkHref='#icon-arrow-right'></use>
                    </svg>
                </span>
            </button>
            {getFooterLink()}
        </div>
    );
}

SSOFormFooter.propTypes = {
    footerButtonText: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isHidden: PropTypes.bool,
    linkCallBackUrl: PropTypes.func,
    footerLinkText: PropTypes.string
};

export default SSOFormFooter;
